import "react-tooltip/dist/react-tooltip.css";
import ChartNav from "../../../common/ChartNav";
import { useSelector } from "react-redux";
import MedicalSummary from "../../clinical-services/medical-summary/medicalSummary";
import MinorAliments from "../../clinical-services/medical-summary/minorAliments";
import FormIcons from "../../clinical-services/medical-summary/FormIcons";

const PatientMedicalSummary = () => {
  const { patient } = useSelector((state) => state.patients);
  if (!patient) return null;

  return (
    <div className="relative flex flex-col flex-1 gap-4 bg-white pt-5">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <MedicalSummary open={true} patient={patient} />
        </div>
      </div>
    </div>
  );
};

export default PatientMedicalSummary;
